import React from 'react';

interface IArrowForCheckboxProps {
    width?: number;
    height?: number;
}

const ArrowForCheckbox: React.FC<IArrowForCheckboxProps> = ({width=20, height=20}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M3.3335 13.3335L10.0002 6.66683"
                    stroke="currentColor" strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.668 13.3335L10.0013 6.66683"
                    stroke="currentColor" strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </g>
        </svg>

    );
};

export default ArrowForCheckbox;